<template>
  <div class="followlist">
    <div class="followlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom:0px;"
        @submit.native.prevent
      >
        <el-form-item label="巡更人">
          <el-input
            v-model.trim="formInline.userName"
            placeholder="请输入巡更人"
            clearable
            style="width: 150px;"
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="巡更位置">
          <el-input
            v-model.trim="formInline.location"
            placeholder="请输入巡更位置"
            clearable
            style="width: 150px;"
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="巡更开始时间">
          <el-date-picker
            v-model="formInline.startTime"
            type="datetime"
            placeholder="选择日期时间"
            clearable
            style="width: 180px;"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="巡更结束时间">
          <el-date-picker
            v-model="formInline.endTime"
            type="datetime"
            placeholder="选择日期时间"
            clearable
            style="width: 180px;"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            icon="el-icon-search"
            plain @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="info" icon="el-icon-document" plain @click="downLoad"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <!-- 封装的 i-table组件 -->
        <div class="table-page">
          <i-table
            :list="list"
            @handleSelectionChange="handleSelectionChange"
            :options="options"
            :columns="columns"
            :operates="operates"
          ></i-table>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import iTable from "@/components/iTable.vue";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      formInline: {
        userName: "",
        pointNo: "",
        startTime: "",
        endTime: ""
      },
      options: {
        stripe: true, // 是否为斑马纹 table
        //loading: true, // 是否添加表格loading加载动画
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        mutiSelect: false // 是否支持列表项选中功能
      }, // table 的参数
      columns: [
        {
          prop: "userName",
          label: "巡更人",
          align: "center"
        },
        {
          prop: "patrolTime",
          label: "巡更时间",
          align: "center"
        },
        {
          prop: "location",
          label: "巡更位置",
          align: "center"
        },
        {
          prop: "greatNo",
          label: "巡更棒编号",
          align: "center"
        },
        {
          prop: "pointNo",
          label: "巡更点编号",
          align: "center"
        }
      ], // 需要展示的列
      operates: {
        width: 0,
        fixed: "right",
        offset: 20,
        list: []
      } // 列操作按钮
    };
  },
  methods: {
    // 选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },

    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (this.formInline.userName == "") {
        this.getTableData(this.formInline.userName, (this.pageNum = 1));
      } else {
        this.getTableData(
          // this.formInline.userName,
          (this.pageNum = 1),
          (this.pageSize = 8)
        );
      }
    },

    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.userName != null) {
        if (this.formInline.userName == "") {
          this.getTableData(this.formInline.userName, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.userName,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    },
    //获取表格数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userName: this.formInline.userName,
        location: this.formInline.location,
        startTime: this.formInline.startTime,
        endTime: this.formInline.endTime
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/patrolRecord/queryListWithPage", param).then(res => {
        console.log(res);
        //判断是否有数据
        if (res.result.list.length != 0) {
          this.pageSize = res.result.pageSize;
          this.currentPage = res.result.pageNum;
          this.totalDataNumber = res.result.total * 1;
          this.list = res.result.list;
          //this.$set(this.tableData,res.result.list)
          console.log(this.list);
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.list = [];
          this.totalDataNumber = 0;
          setTimeout(() => {
            this.loading = false;
          }, 3000);
        }
      });
    },
    //模板下载
    downLoad() {
      let userName = ``;
      let location = ``;
      let startTime = ``;
      let endTime = ``;
      if (this.formInline.userName) {
        userName = `&userName=${this.formInline.userName}`;
      }
      if (this.formInline.location) {
        location = `&location=${this.formInline.location}`;
      }
      if (this.formInline.startTime) {
        startTime = `&startTime=${this.formInline.startTime}`;
      }
      if (this.formInline.endTime) {
        endTime = `&endTime=${this.formInline.endTime}`;
      }
      window.location.href =
        baseURL +
        `dmc/api/patrolRecordDown?groupId=${sessionStorage.getItem(
          "groupId"
        )}${userName}${location}${startTime}${endTime}`;
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    }
  },

  watch: {
    currentPage(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    //  tableData(newV,oldV) {
    //      console.log(newV,oldV);
    //      deep: true  //深度监听
    // },
    data: "onSubmit" //值可以为methods的方法
  },

  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.getTableData();
  },

  mounted() {
    //监听submitFormchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormchange_follow", () => {
      this.getTableData();
    }),
      //监听handleDeletechange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("handleDeletechange_follow", () => {
        this.getTableData();
      }),
      //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("submitFormEditchange_follow", () => {
        this.getTableData();
      }),
      this.getTableData();
  },
  components: { iTable }
};
</script>
<style lang="scss" scoped>
.followlist {
  .followlist-m {
    padding: 10px 0 0 5px;
  }
}

// 修改element-ui默认的样式
.del {
  color: red !important;
}
.fangqu {
  color: green !important;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .followxz .el-dialog {
    width: 30% !important;
  }
}

//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .followedit .el-dialog {
    width: 30% !important;
  }
}
</style>
